// src/routes.js
import React from "react";
import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdOutlineShoppingCart,
  MdChecklist
} from "react-icons/md";

// Admin pages
import Dashboard from "views/admin/default";
import Products from "views/admin/products";
import Inventory from "views/admin/inventory";
import Profile from "views/admin/profile";
import Actions from "views/admin/actions";
// Landing (비관리자용)
import LandingPage from "views/landing";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "/default",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: Dashboard,
  },
  {
    name: "Products",
    layout: "/admin",
    path: "/products",
    icon: (
      <Icon as={MdOutlineShoppingCart} width="20px" height="20px" color="inherit" />
    ),
    component: Products,
  },
  {
    name: "Inventory",
    layout: "/admin",
    path: "/inventory",
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: Inventory,
  },
    {
    name: "Actions",
    layout: "/admin",
    path: "/actions",
    icon: <Icon as={MdChecklist} width="20px" height="20px" color="inherit" />,
    component: Actions,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "/profile",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: Profile,
  },
  {
    name: "Landing",
    layout: "/",
    path: "/landing",
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: LandingPage,
  },
];

export default routes;